<template>
  <div class="admin-user-role-list px-2 px-md-4 py-2 py-md-4 w-100 h-100">
    <ConveyTable
      showSearch
      :showCreate="$permission('create:user')"
      tableClassName="admin-user-role-table"
      :items="roles"
      :fields="fields"
      :placeholders="placeholders"
      :perPageOptions="perPageOptions"
      :perPage="perPage"
      :currentPage="currentPage"
      :totalRows="totalRows"
      :isLoading="isFetchingRoles"
      @onFetch="(options) => fetchUserRoles(options)"
      @onCreate="addRole"
    >
      <template #create-icon>
        <b-icon icon="plus"></b-icon>
      </template>
      <template #create-label>
        Add User Role
      </template>
      <template #cell(role)="data">
        <router-link :to="`/admin/roles/${data.item.role_id}`">
          {{ data.value || "-" }}
        </router-link>
      </template>
      <template #cell(permissions)="data">
        <div class="d-flex align-items-center justify-content-center flex-wrap gap-1">
          <b-badge v-for="permission in data.value" :key="permission">
            {{ permission }}
          </b-badge>
        </div>
      </template>
      <template #cell(created_at)="data">
        {{ formatDate(data.value, "MMM D, YYYY h:mm a") }}
      </template>
      <template #cell(updated_at)="data">
        {{ formatDate(data.value, "MMM D, YYYY h:mm a") }}
      </template>
    </ConveyTable>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import formatter from "@/mixins/formatter";
import errorHandler from "@/mixins/errorHandler";
import ConveyTable from "@/components/ConveyTable";

export default {
  name: "AdminUserRoleList",
  mixins: [formatter, errorHandler],
  components: { ConveyTable },
  data() {
    return {
      roles: [],
      perPage: 10,
      perPageOptions: [5, 10, 25, 50, 100],
      currentPage: 1,
      totalRows: 0,
      isFetchingRoles: false,
      placeholders: {
        search: "Search..."
      },
      fields: [
        { key: "role", label: "Role", sortable: false },
        { key: "permissions", label: "Permissions", sortable: false },
        { key: "created_at", label: "Created At", sortable: false },
        { key: "updated_at", label: "Updated At", sortable: false },
      ],
      fetchAbortController: null,
    };
  },
  computed: {
    ...mapGetters("agency", ["currentAgencyId"]),
  },
  methods: {
    abortFetchOperation() {
      if (this.fetchAbortController) {
        this.fetchAbortController.abort();
        this.fetchAbortController = null;
      }
    },
    async fetchUserRoles(fetchOptions) {
      try {
        this.abortFetchOperation();
        this.fetchAbortController = new AbortController();
        const {
          currentPage,
          perPage,
          searchKey
        } = fetchOptions;

        this.currentPage = currentPage;
        this.perPage = perPage;
        this.isFetchingRoles = true;

        const offset = (currentPage - 1) * perPage;
        const params = {
          offset,
          limit: perPage,
        };

        if (searchKey) {
          params['search'] = searchKey;
        }

        const resp = await this.$ConveyApi.agenciesApi.getAgencyRoles({
          agencyId: this.currentAgencyId,
          params,
          signal: this.fetchAbortController.signal,
        });
        const { data, metadata } = resp.data;
        this.roles = data && data.length > 0 ? [...data] : [];
        this.totalRows = metadata ? metadata.totalRows || 0 : 0;
      } catch (err) {
        if (!this.isApiCanceled(err)) {
          console.log("[AdminUserRoleList:fetchUserRoles] ERROR: ", err);
        }
      } finally {
        this.isFetchingRoles = false;
      }
    },
    addRole() {
      this.$router.push({ name: "Admin Create User Role" }).catch(() => {});
    }
  },
  beforeDestroy() {
    this.abortFetchOperation();
  }
};
</script>

<style lang="scss">
</style>